module.exports = require("./dist/angular-file-upload.min.js");


//////////////////
// WEBPACK FOOTER
// angular-file-upload (bower component)
// module id = 503
// module chunks = 0